import { SiteSearchConsoleFormValidationSchema } from '@/modules/Domains';


export const siteSearchConsoleFormValidationSchema: SiteSearchConsoleFormValidationSchema = {
  searchConsoleAccountId: [{
    required: true,
    message: 'Виберіть обліковий запис Search Console'
  }]
};
